// The `background.section.*` token path for each `background` variant
// `ModuleContainer` accepts. `inverse` has no color of its own (see
// `ModuleContainer`) and paints as `strong`, so it reads that token too.
// Exported as plain token paths — not resolved vars — so `ModuleContainer`'s
// own recipe (`module-container/index.recipe.js`) can import this instead of
// re-declaring the same variant→token mapping: Panda resolves a token path
// written directly in a recipe at build time, same as any other recipe
// color, and can't do the same for a value that's already been resolved.
export const SECTION_BG_VAR = {
    default: 'background.section.default',
    subtle: 'background.section.subtle',
    strong: 'background.section.strong',
    inverse: 'background.section.strong'
}

/**
 * Derives the Xleap header/breadcrumb background from the first module's own
 * `background` variant (`default`/`subtle`/`strong`/`inverse`, the same prop
 * `ModuleContainer` takes), so the page reads as one surface behind the header.
 *
 * Returns the CSS var, not a resolved color: it resolves against the page theme
 * that `PageTheme` publishes on `<html>`.
 *
 * @param {import('@chakra-ui/react3').SystemContext} system - The active Chakra v3
 *   system (`useChakraContext()`), used to resolve the token path to its CSS var.
 * @param {Array<{background?: string}>} [modules] - The page's CMS modules, in order.
 * @returns {string|undefined} The CSS var for the first module's background, or
 *   `undefined` when there is no first module yet (loading/empty).
 */
export const getHeaderBgFromFirstModule = (system, modules) => {
    const firstModule = Array.isArray(modules) ? modules[0] : undefined
    if (!firstModule) {
        return undefined
    }
    const variant = SECTION_BG_VAR[firstModule.background] ? firstModule.background : 'default'
    return system.css({color: SECTION_BG_VAR[variant]}).color
}
